import { createFileRoute } from '@tanstack/react-router'

import { OnboardingPage } from '@/features/onboarding/pages'

export const Route = createFileRoute('/_shell/onboarding')({ component: OnboardingPage })
